const stories = [
  {
    image: 'https://img.freepik.com/free-photo/successful-happy-business-team_53876-74892.jpg',
    title: 'TechCorp Success Story',
    description: 'TechCorp streamlined their operations with our cutting-edge solution, achieving remarkable results in efficiency and customer satisfaction across their global teams.',
    stats: [
      { label: 'Efficiency Increase', value: '40%' },
      { label: 'Customer Retention', value: '95%' },
      { label: 'Revenue Growth', value: '25%' },
    ],
  },
  {
    image: 'https://static.vecteezy.com/system/resources/thumbnails/013/577/994/small_2x/starting-new-working-day-as-a-team-top-view-of-group-of-six-young-people-holding-hands-together-and-smile-while-sitting-at-the-office-desk-photo.jpg',
    title: 'GrowEasy Analytics',
    description: 'GrowEasy leveraged our advanced analytics platform to gain deep insights, driving significant business growth and market expansion.',
    stats: [
      { label: 'Data Accuracy', value: '98%' },
      { label: 'Processing Speed', value: '3x' },
      { label: 'Market Share', value: '15%' },
    ],
  },
  {
    image: 'https://cdn.create.vista.com/api/media/small/151403040/stock-photo-business-team-celebrating-success',
    title: 'HealthPlus Transformation',
    description: 'HealthPlus revolutionized patient care using our integrated healthcare solutions, improving outcomes and operational efficiency.',
    stats: [
      { label: 'Patient Satisfaction', value: '90%' },
      { label: 'Response Time', value: '-30%' },
      { label: 'Cost Savings', value: '$2M' },
    ],
  },
  {
    image: 'https://media.istockphoto.com/id/1346125184/photo/group-of-successful-multiethnic-business-team.jpg?s=612x612&w=0&k=20&c=5FHgRQZSZed536rHji6w8o5Hco9JVMRe8bpgTa69hE8=',
    title: 'EcoSolutions Impact',
    description: 'EcoSolutions adopted our sustainable technology platform to reduce their carbon footprint and enhance operational sustainability.',
    stats: [
      { label: 'Carbon Reduction', value: '50%' },
      { label: 'Energy Efficiency', value: '35%' },
      { label: 'Operational Uptime', value: '99%' },
    ],
  },
];

export default stories;